module.exports = __webpack_public_path__ + "img/edge_divers_geocaching.6ed49370.svg";